import { useState } from '#imports'
import { type Ref, onBeforeUnmount, onMounted, ref, watch } from 'vue'

import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { useScrollLock } from '@vueuse/core'

import { useActiveMenu } from './useActiveMenu'

export function useBurgerMenuState() {
  const { trackClick } = useTracking()
  const { clearActiveMenu } = useActiveMenu()

  const isOpen = useState('burger-menu-isOpen', () => false)

  const pageScrollTarget = ref<HTMLElement | null>(
    null,
  ) as Ref<HTMLElement | null>
  const isPageScrollLocked = useScrollLock(pageScrollTarget)
  let preventTouch: (e: TouchEvent) => void

  onMounted(() => {
    pageScrollTarget.value = document.documentElement

    preventTouch = (e: TouchEvent) => {
      if (!(e.target as HTMLElement).closest('.scrollable')) {
        e.preventDefault()
      }
    }
  })

  watch(isPageScrollLocked, (locked) => {
    if (locked) {
      document.addEventListener('touchmove', preventTouch, { passive: false })
    } else {
      document.removeEventListener('touchmove', preventTouch)
    }
  })

  watch(isOpen, (opened) => {
    isPageScrollLocked.value = opened
  })

  onBeforeUnmount(() => {
    document.removeEventListener('touchmove', preventTouch)
  })

  function close(): void {
    clearActiveMenu()
    isOpen.value = false
  }

  function toggle(): void {
    clearActiveMenu()
    isOpen.value = !isOpen.value
    if (isOpen.value) {
      trackClick({ zone: 'nav', name: 'all_product' })
    }
  }

  return {
    isOpen,
    close,
    toggle,
  }
}
